import React from 'react'
import moment from 'moment'
import { Row, Col, Typography, Card, Modal, List, Form, Input, DatePicker, Upload, Button } from 'antd'
import { ExclamationCircleOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons'

import { useRedux } from '../redux'
import { useFirebase } from '../firebaseContext'
import { openNotification, generateKeywords } from '../functions'

const { Title } = Typography
const { confirm } = Modal

export default function Offers() {
  const [items, setItems] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [fileList, setFileList] = React.useState([])
  const [file, setFile] = React.useState(null)
  const firebase = useFirebase()
  const actions = useRedux()

  const [form] = Form.useForm()

  React.useEffect(() => {
    const ref = firebase.getCollectionRef('offers').orderBy('created', 'desc').limit(20)
    const unsuscribe = ref.onSnapshot(async snap => {
      let array = []
      actions.setAppLoading(true)
      await Promise.all(snap.docs.map(async post => {
        const item = { id: post.id, ...post.data() }
        array.push(item)
      }))
      setItems(array)
      actions.setAppLoading(false)
    })
    return () => {
      unsuscribe()
    }
  }, [])

  const resetForm = () => {
    form.resetFields()
    setFileList([])
    setFile(null)
    setLoading(false)
    actions.setAppLoading(false)
  }

  const handleSubmit = values => {
    if(!file){
      openNotification(
        'info',
        'Promociones',
        'Por favor selecciona una imagen.'
      )
      return
    }
    setLoading(true)
    actions.setAppLoading(true)
    const ref = firebase.getStorageFile('/offers', file)
    ref.put(file).then(async snap => {
      const image = await snap.ref.getDownloadURL()
      const dt = firebase.toDate(values.expires.toDate())
      const data = { title: values.title, expires: dt, image: image, keywords: generateKeywords(values.title), created: firebase.getServerTime() }
      firebase.getCollectionRef('offers').add(data)
      .then(docRef => {
        openNotification(
          'success',
          'Promociones',
          'Promoción guardada correctamente.'
        )
        resetForm()
      })
      .catch(error => {
        openNotification(
          'error',
          'Promociones',
          error.message
        )
        setLoading(false)
        actions.setAppLoading(false)
      })
    })
  }

  const showConfirm = item => {
    confirm({
      title: 'Promociones',
      icon: <ExclamationCircleOutlined />,
      content: '¿Estás seguro de eliminar está promoción?',
      okText: 'Aceptar',
      cancelText: 'Cancelar',
      onOk() {
        firebase.getDocRef('offers', item.id).delete()
        .then(() => {
          openNotification(
            'success',
            'Promociones',
            'Promoción eliminada correctamente.'
          )
          resetForm()
        })
        .catch(error => {
          openNotification(
            'error',
            'Promociones',
            error.message
          )
          setLoading(false)
        })
      },
      onCancel() {
        console.log('Canceled')
      },
    })
  }

  return (
    <div>
      <Title level={2}>Promociones</Title>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={16}>
          <Card>
            <Form
              name="post"
              form={form}
              initialValues={{ title: '', expires: '' }}
              onFinish={handleSubmit}>
              <React.Fragment>
                <Form.Item
                  name="title"
                  rules={[
                    { max: 64, message: 'Superaste el limite de caracteres para este campo.' },
                    { required: true, message: 'Este campo es requerido.' },
                  ]}>
                  <Input placeholder="Títlulo" />
                </Form.Item>
                <Form.Item name="expires" rules={[
                  { required: true, message: 'Por favor seleccione una fecha.' },
                ]}>
                  <DatePicker
                    placeholder="Fecha de expiración"
                    disabledDate={c => {return c && c < moment().endOf('day')}}
                    showToday={false}
                    style={{width: '100%'}}
                  />
                </Form.Item>
                <Upload
                  accept='image/*'
                  fileList={fileList}
                  onChange={e => {
                    setFileList(e.fileList)
                  }}
                  onRemove={file => {
                    setFile(null)
                  }}
                  beforeUpload={file =>{
                    setFile(file)
                    return false
                  }}
                  listType="picture"
                  maxCount={1}>
                  <Button icon={<UploadOutlined />}>Seleccionar imagen</Button>
                </Upload>
              </React.Fragment>
              <Form.Item style={{ marginTop: 20 }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Publicar
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={8}>
          <Card>
            <List
              itemLayout="horizontal"
              dataSource={items}
              renderItem={item => (
                <List.Item actions={[<Button type="text" onClick={() => showConfirm(item)} icon={<DeleteOutlined />} />]}>
                  <List.Item.Meta
                    title={item.title}
                    // description={humanizeType(item.type)}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  )
}